/**
 * Hook for fetching triage threads (needs_review = true).
 */

import {useQuery} from '@tanstack/react-query';
import {useRequiredTenantId} from '@/matic/hooks/useRequiredTenantId';
import {getRelayApi} from '../api/relay-api';
import {relayKeys} from '../query-keys';
import type {ThreadListResponse} from '../types/relay-types';

export function useTriageThreads() {
  const tenantId = useRequiredTenantId();
  const api = getRelayApi();

  return useQuery<ThreadListResponse>({
    queryKey: relayKeys.threads.triage(tenantId),
    queryFn: async () => api.getTriageThreads(),
    staleTime: 30_000,
    // EnrichmentSweeper enrichment/dedup runs asynchronously and can flip
    // needsReview or attach signals with no push channel to the browser.
    refetchInterval: 30_000,
  });
}
